const API_BASE_URL = process.env.BASE_URL

export const USER_ENDPOINT = API_BASE_URL + "/user/me/"

export const USERS_ENDPOINTS = {
    WORKING_TECHNICIANS: API_BASE_URL + "/{service_company_slug}/api/users/working-technicians/",
}
